export const VERSION = '4.7.0';
// export const BASE_URL = 'https://edunix-api.beetronix.com';
export const BASE_URL = 'https://api.sawa.edunixsystem.com';
// export const BASE_URL = 'https://api.albayan-schools.com';
export const TRANSPORT_BASE_URL = 'https://mirror-transport.mirror.edunixsystem.com';
